<template>
  <div>
    <div style="display:none">{{unreadFlag}}</div>
    <div :class="SelectClass()">
      <div class="g-List foo">
        <vue-custom-scrollbar
          class="scroll-area fullHeight"
          :settings="settings"
          @ps-scroll-y="scrollHanle"
          v-chat-scroll
        >
          <ul class="fullHeight">
            <li
              v-for="(item,index) in groupList"
              :class="{ 'act': index == selected }"
              @click="choose(index,item)"
              @dragover="allowDrop($event)"
              @drop="drop($event, item, index)"
            >
              <img class="group-img" :src="item.FriendGroupPhotoURL" alt />
              <h4>{{item.GroupName}}</h4>
              <div
                v-if="(item.GroupSysType=='unreadlist' || item.GroupSysType=='all' ) && GroupUnreadCount!='0'"
              >
                <span>{{GroupUnreadCount}}</span>
              </div>
              <a
                v-show="item.GroupSysType == '' ||item.GroupSysType == 'unknownmotivation'"
                class="addFriend"
                @click.stop="showDialog(item)"
              ></a>
            </li>
          </ul>
        </vue-custom-scrollbar>
      </div>
      <a class="g-build" @click="showDialog()">
        建立群組
        <img src="../../../static/img/add.png" alt />
      </a>
    </div>
  </div>
</template>

<script>
import { FriendGroupHandler } from "../../handler/FriendGroup.js";
import { FriendListHandler } from "../../handler/FriendListHandler.js";
import 'vue-custom-scrollbar/dist/vueScrollbar.css';
import { Notification } from "element-ui";
import { isMobile } from "mobile-device-detect";
import store from "../../vuex/store_friendList.js";
import store_groupList from "../../vuex/store_groupList.js";
export default {
  computed: {
    unreadFlag() {
      if (store_groupList.state.unreadGroupShow > 0) {
        //取得未讀清單
        FriendListHandler.QueryUnreadList(this.staff.staffid);
        var obj = this.groupList.filter(function(elem) {
          if (elem.GroupSysType == "unreadlist") return elem;
        });

        if (obj.length > 0) {
          this.selected = 4;
          this.$emit("setChoiseGroup", obj[0]);
        }
      }

      return store_groupList.state.unreadGroupShow;
    },
    GroupUnreadCount: {
      get: function() {
        var unread = store.state.groupUnread;
        if (unread == null && unread == undefined) {
          return "0";
        }

        if (unread.length == 0) {
          return "0";
        }

        if (unread.TotalNum > 999) {
          return "999+";
        }

        return unread.TotalNum;
      },
      set: function() {}
    },
    groupList: {
      get: function() {
        return store_groupList.state.groupList;
      },
      set: function() {}
    }
  },
  props: ["mode"],
  data() {
    return {
      staff: [],
      selected: 0,
      groupId: "",
      loading: false,
      friendGroupPhotoURL: "",
      groupClassName: "",
      settings: {
        maxScrollbarLength: 60
      }
    };
  },
  created() {
    if (this.mode != undefined && this.mode.type == "Mobile") {
      this.staff = this.mode.staff;
    } else {
      this.staff = this.GetLoginStaff();
    }
    FriendGroupHandler.GetGroup(this.staff.staffid);

    //取得未分類清單
    FriendListHandler.QueryUnclassifiedList(this.staff.staffid);
  },
  methods: {
    choose: function(index, item) {
      this.selected = index;

      switch (item.GroupSysType) {
        case "all":
          //取得全部好友
          FriendListHandler.GetFriendList(this.mode.token);
          break;
        case "unreadlist":
          //取得未讀清單
          FriendListHandler.QueryUnreadList(this.staff.staffid);
          break;
        case "unclass":
          //取得未分類清單
          FriendListHandler.QueryUnclassifiedList(this.staff.staffid);
          break;
        case "salerecently":
          //取得最近聯繫業務
          FriendListHandler.QueryRecentlyStaffMainContact(
            this.staff.staffid,
            0
          );
          break;
        case "custrecently":
          //取得最近聯繫客戶
          FriendListHandler.QueryRecentlyStaffMainContact(
            this.staff.staffid,
            1
          );
          break;
        case "todaycontact":
          //今日應聯
          FriendListHandler.QueryTodayStaffMainContact(this.staff.staffid);
          break;
        default:
          //取得群組好友
          FriendListHandler.GetGroupFriendList(item.Id, this.staff.staffid);
          break;
      }

      this.$emit("setChoiseGroup", item);
    },
    friendCount: function(groupId) {
      var friendItem = FriendListHandler.GetGroupFriendItem(
        groupId,
        this.staff.staffid
      );
      return friendItem.length;
    },
    drop(e, item, index) {
      this.allowDrop(e);
      var nodrop =
        item.GroupSysType != undefined && item.GroupSysType.length > 0;

      if (
        item.GroupSysType == "noanswer" ||
        item.GroupSysType == "unknownmotivation"
      ) {
        nodrop = false;
      }

      if (nodrop) {
        this.$notify({
          title: "警告",
          message: "好友群組" + item.GroupName + "不能使用拖拉加入好友功能",
          type: "warning",
          position: "top-left"
        });
        return;
      }

      FriendListHandler.AddFriendGroupItem(
        e.dataTransfer.getData("socialLeadId"),
        item.Id,
        this.staff.staffid
      );
      this.$notify({
        title: "成功",
        message:
          "客戶" +
          e.dataTransfer.getData("socialLeadName") +
          "已成功加入" +
          item.GroupName +
          "好友群組",
        type: "success",
        position: "top-left"
      });
    },
    allowDrop(e) {
      e.preventDefault();
    },
    SelectClass() {
      if (isMobile) {
        return "group_M";
      } else {
        return "group";
      }
    },
    scrollHanle(evt) {},
    showDialog: function(item) {
      store_groupList.dispatch("showDialog", item);
    }
  }
};
</script>
<style scoped>
.popup .p-foot.editgroup a {
  min-width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/FriendGroup.vue